import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

export const MenuIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="20" cy="20" r="19.5" fill="white" stroke="#D9D9D9" />
      <rect x="12" y="14" width="16" height="2" rx="1" fill="black" />
      <rect x="12" y="19" width="16" height="2" rx="1" fill="black" />
      <rect x="12" y="24" width="16" height="2" rx="1" fill="black" />
    </svg>
  </SvgIcon>
);

export default MenuIcon;
